(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5902,5342],{

/***/ 27049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59844);



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





var Divider = function Divider(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_config_provider__WEBPACK_IMPORTED_MODULE_2__/* .ConfigConsumer */ .C, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls,
        direction = _ref.direction;

    var customizePrefixCls = props.prefixCls,
        _props$type = props.type,
        type = _props$type === void 0 ? 'horizontal' : _props$type,
        _props$orientation = props.orientation,
        orientation = _props$orientation === void 0 ? 'center' : _props$orientation,
        className = props.className,
        children = props.children,
        dashed = props.dashed,
        plain = props.plain,
        restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed", "plain"]);

    var prefixCls = getPrefixCls('divider', customizePrefixCls);
    var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
    var hasChildren = !!children;
    var classString = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-with-text"), hasChildren), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), hasChildren), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-plain"), !!plain), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      className: classString
    }, restProps, {
      role: "separator"
    }), children && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: "".concat(prefixCls, "-inner-text")
    }, children));
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Divider);

/***/ }),

/***/ 66607:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}}));

/***/ }),

/***/ 79212:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";return function(e,t){t.prototype.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)}}}));

/***/ }),

/***/ 37412:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i){i.prototype.isSameOrBefore=function(e,i){return this.isSame(e,i)||this.isBefore(e,i)}}}));

/***/ }),

/***/ 36707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RA": function() { return /* binding */ verifyAuth; },
/* harmony export */   "bG": function() { return /* binding */ sendAuthOtp; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "kS": function() { return /* binding */ logout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61619);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);






/**
 * send otp to verify mobile number for authentication
 * @param mobileNo target mobile number
 * @param lang otp langauge message
 * @returns reference number otp and is found user in retail platform flag
 */ var sendAuthOtp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(mobileNo, lang) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/send-otp", {
                            mobileNo: mobileNo
                        }, {
                            headers: {
                                "Accept-Language": lang
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendAuthOtp(mobileNo, lang) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * get user profile from access token in cookies
 * @returns user's profile
 */ var getUserProfile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("/api/retail/auth/user/me")
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getUserProfile() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Function to verify authentication.
 * @return atk, rtk, isAlreadyRegistered and expired datetime
 */ var verifyAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(payload) {
        var res, result, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/login", payload)
                    ];
                case 1:
                    res = _state.sent();
                    result = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, res.data), {
                        timestamp: res.headers.date
                    });
                    return [
                        2,
                        result
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function verifyAuth(payload) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * logout by access token in cookies
 * @returns empty object
 */ var logout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/logout", {}, {
                            withCredentials: true,
                            headers: {
                                credentials: "same-origin"
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function logout() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 26451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ submitDirectLinkDropLead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20414);
/* harmony import */ var src_utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14744);
/* harmony import */ var _http_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55642);
/* eslint-disable import/prefer-default-export */ 



var submitDirectLinkDropLead = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(droplead) {
        var res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .clientHttpInstance.post */ .hL.post("/drop-lead/submit", droplead)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    (0,src_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .logError */ .H)("[drop-lead-direct-link] send lead fail", {}, error);
                    return [
                        2,
                        error
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function submitDirectLinkDropLead(droplead) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 76922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ID": function() { return /* binding */ searchPlan; },
/* harmony export */   "Ye": function() { return /* binding */ getPlanWithPricing; },
/* harmony export */   "dv": function() { return /* binding */ getProductMatchedPricingItem; },
/* harmony export */   "gl": function() { return /* binding */ getPlanMatchedPricingItem; }
/* harmony export */ });
/* unused harmony exports getPlanByCode, getPlanStarterPrice, getPlanGroup, getStarterPricePlanGroup */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20414);
/* harmony import */ var src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61619);
/* harmony import */ var _http_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55642);
/* eslint-disable import/prefer-default-export */ 



/**
 *get plan by code
 * @param code plan code
 * @param categoryCode cartegory code
 * @returns plan
 */ var getPlanByCode = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(code, categoryCode, channelCode) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .clientHttpInstance.get */ .hL.get("/channels/".concat(channelCode, "/product-categories/").concat(categoryCode, "/plans/").concat(code))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPlanByCode(code, categoryCode, channelCode) {
        return _ref.apply(this, arguments);
    };
}();
var searchPlan = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(channelCode, categoryCode, data) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .clientHttpInstance.post */ .hL.post("/channels/".concat(channelCode, "/product-categories/").concat(categoryCode, "/plans/search"), data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function searchPlan(channelCode, categoryCode, data) {
        return _ref.apply(this, arguments);
    };
}();
var getPlanStarterPrice = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(channelCode, categoryCode, planCode) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .serverHttpInstance.get */ .H$.get("/channels/".concat(channelCode, "/product-categories/").concat(categoryCode, "/plans/").concat(planCode, "/starter-price"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPlanStarterPrice(channelCode, categoryCode, planCode) {
        return _ref.apply(this, arguments);
    };
}();
var getPlanMatchedPricingItem = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(planCode, categoryCode, channelCode, entryFormInputs, customizations, priceImpactInputs) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .clientHttpInstance.post */ .hL.post("/channels/".concat(channelCode, "/product-categories/").concat(categoryCode, "/plans/").concat(planCode, "/pricing"), {
                            entryFormInputs: entryFormInputs,
                            customizations: customizations,
                            priceImpactInputs: priceImpactInputs
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPlanMatchedPricingItem(planCode, categoryCode, channelCode, entryFormInputs, customizations, priceImpactInputs) {
        return _ref.apply(this, arguments);
    };
}();
var getPlanWithPricing = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(planCode, categoryCode, channelCode, entryFormInputs) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .clientHttpInstance.post */ .hL.post("/channels/".concat(channelCode, "/product-categories/").concat(categoryCode, "/plans/").concat(planCode), {
                            entryFormInputs: entryFormInputs
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPlanWithPricing(planCode, categoryCode, channelCode, entryFormInputs) {
        return _ref.apply(this, arguments);
    };
}();
var getPlanGroup = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(channelCode, categoryCode, productCode) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .serverHttpInstance.get */ .H$.get("/channels/".concat(channelCode, "/product-categories/").concat(categoryCode, "/products/").concat(productCode, "/plans"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPlanGroup(channelCode, categoryCode, productCode) {
        return _ref.apply(this, arguments);
    };
}();
var getStarterPricePlanGroup = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(channelCode, categoryCode, productCode) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .serverHttpInstance.get */ .H$.get("/channels/".concat(channelCode, "/product-categories/").concat(categoryCode, "/products/").concat(productCode, "/starter-price"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getStarterPricePlanGroup(channelCode, categoryCode, productCode) {
        return _ref.apply(this, arguments);
    };
}();
var getProductMatchedPricingItem = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(productCode, categoryCode, channelCode, entryFormInputs) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .clientHttpInstance.post */ .hL.post("/channels/".concat(channelCode, "/product-categories/").concat(categoryCode, "/products/").concat(productCode, "/pricing"), {
                            entryFormInputs: entryFormInputs
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getProductMatchedPricingItem(productCode, categoryCode, channelCode, entryFormInputs) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 94665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_api_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36707);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(435);
/* harmony import */ var src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85760);










// allow user or guest to access this page
// if user is authorized, header will display user header with user data to child component.
// if user not authorized, header will display guest header and able to log in/sign up.
var withUserOrGuest = function(WrappedComponent) {
    return function(props) {
        var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), user = ref[0], setUser = ref[1];
        var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoadSuccess = ref1[0], setIsLoadSuccess = ref1[1];
        var isRetail = src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__/* .LOGICAL_GROUP_CHANNEL_CODE */ .V === src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__/* .RETAIL_LOGICAL_GROUP_CHANNEL_CODE */ .b;
        (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
            var fetchGetProfile = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var result, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0,src_api_auth__WEBPACK_IMPORTED_MODULE_6__/* .getUserProfile */ .et)()
                                ];
                            case 1:
                                result = _state.sent();
                                setUser(result);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                setUser(null);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                setIsLoadSuccess(true);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchGetProfile() {
                    return _ref.apply(this, arguments);
                };
            }();
            // fetch user data once only, prevent unnecessary fetch from other state.
            if (!isLoadSuccess) {
                fetchGetProfile();
            }
        }, [
            isLoadSuccess,
            router
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: isLoadSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                user: user,
                headerType: isRetail ? src_constants_layout__WEBPACK_IMPORTED_MODULE_9__/* .HEADER_TYPE.PROFILE */ .N.PROFILE : src_constants_layout__WEBPACK_IMPORTED_MODULE_9__/* .HEADER_TYPE.PARTNER */ .N.PARTNER
            }))
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withUserOrGuest);


/***/ }),

/***/ 26331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LandingPageRetailCategoryCard_LandingPageRetailCategoryCard; },
  "y": function() { return /* binding */ getLandingPageRetailProductCategoryCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/lib/skeleton/Avatar.js
var Avatar = __webpack_require__(434);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/params.ts
var params = __webpack_require__(62090);
// EXTERNAL MODULE: ./src/types/productType.ts
var productType = __webpack_require__(80948);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(65934);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./node_modules/antd/es/card/index.js + 2 modules
var card = __webpack_require__(97751);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
;// CONCATENATED MODULE: ./src/components/CategoryCard/LandingPageRetailCategoryCard/LandingPageRetailCategoryCard.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  border-radius: 12px;\n  border: 1px solid ",
        ";\n  height: 148px;\n  ",
        " {\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  height: 20px;\n  align-self: start;\n  margin-bottom: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 64px;\n  height: 64px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  ",
        " {\n    height: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-right: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n  line-height: 23.1px;\n  text-align: left;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n  line-height: 23.1px;\n  text-align: left;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  .ant-skeleton-title {\n    height: 14px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var Card = (0,styled_components_browser_esm/* default */.ZP)(card/* default */.Z).withConfig({
    componentId: "sc-adeff9fd-0"
})(_templateObject(), globals/* color.charcoal05 */.$.charcoal05, (0,styled_breakpoints.down)("sm"));
var InsurerImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-adeff9fd-1"
})(_templateObject1());
var CategoryImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-adeff9fd-2"
})(_templateObject2());
var CardDetailContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adeff9fd-3"
})(_templateObject3(), (0,styled_breakpoints.down)("sm"));
var LogoTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adeff9fd-4"
})(_templateObject4());
var DesktopTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-adeff9fd-5"
})(_templateObject5(), (0,styled_breakpoints.down)("sm"));
var MobileTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-adeff9fd-6"
})(_templateObject6(), (0,styled_breakpoints.up)("md"));
var CardContainer = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-adeff9fd-7"
})(_templateObject7());
var SkeletonTitle = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).withConfig({
    componentId: "sc-adeff9fd-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/components/CategoryCard/LandingPageRetailCategoryCard/LandingPageRetailCategoryCard.tsx












var LandingPageRetailCategoryCard = function(_param) {
    var isLoading = _param.isLoading, insurerIcon = _param.insurerIcon, categoryIcon = _param.categoryIcon, displayName = _param.displayName, labels = _param.labels, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isLoading",
        "insurerIcon",
        "categoryIcon",
        "displayName",
        "labels"
    ]);
    var locale = (0,next_router.useRouter)().locale;
    var ref = (0,react.useState)(false), isImageError = ref[0], setIsImageError = ref[1];
    var onImageError = function() {
        setIsImageError(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
            bodyStyle: (0,_object_spread/* default */.Z)({
                padding: "16px",
                width: "100%"
            }, insurerIcon ? {
                height: "100%"
            } : {
                margin: "auto"
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardDetailContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoTitleContainer, {
                        children: [
                            insurerIcon && !isImageError && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(InsurerImage, {
                                src: insurerIcon,
                                alt: "Insurer Icon",
                                onError: onImageError
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonTitle, {
                                loading: true,
                                paragraph: false,
                                title: {
                                    width: 140
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopTitle, {
                                        style: insurerIcon ? {} : {
                                            margin: "auto"
                                        },
                                        children: displayName === null || displayName === void 0 ? void 0 : displayName[locale]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTitle, {
                                        style: insurerIcon ? {} : {
                                            margin: "auto"
                                        },
                                        children: displayName === null || displayName === void 0 ? void 0 : displayName[locale]
                                    })
                                ]
                            })
                        ]
                    }),
                    isImageError || isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        size: 64
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryImage, {
                        src: categoryIcon,
                        alt: "Category Icon",
                        onError: onImageError,
                        style: insurerIcon ? {} : {
                            marginTop: "auto",
                            marginBottom: "auto"
                        }
                    })
                ]
            })
        })
    }));
};
var ProductLinkMapper = function(param) {
    var path = param.path, productCategory = param.productCategory, _insurerIcon = param.insurerIcon, insurerIcon = _insurerIcon === void 0 ? "" : _insurerIcon, categoryIcon = param.categoryIcon;
    var code = productCategory.code, displayName = productCategory.displayName, labels = productCategory.labels;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            pathname: path,
            query: productCategory.type === productType/* default.static */.Z["static"] || productCategory.type === productType/* default.external */.Z.external || productCategory.type === productType/* default.dynamic */.Z.dynamic ? (0,url/* filterParams */.Lt)(router.query, params/* GLOBAL_PARAMS */.g_) : {}
        },
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageRetailCategoryCard, {
                isLoading: false,
                displayName: displayName,
                insurerIcon: insurerIcon,
                categoryIcon: categoryIcon,
                labels: labels,
                "data-cy": "landing-page.product-card.".concat(code)
            }, code)
        })
    });
};
var getLandingPageRetailProductCategoryCard = function(param) {
    var productCategory = param.productCategory, channelPath = param.channelPath;
    switch(productCategory.type){
        case productType/* default.static */.Z["static"]:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLinkMapper, {
                productCategory: productCategory,
                path: (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath, "/").concat(productCategory.code, "/plan")),
                insurerIcon: productCategory.icon.insurer,
                categoryIcon: productCategory.icon.url
            });
        case productType/* default.dynamic */.Z.dynamic:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLinkMapper, {
                productCategory: productCategory,
                path: (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath, "/").concat(productCategory.code)),
                insurerIcon: productCategory.icon.insurer,
                categoryIcon: productCategory.icon.url
            });
        case productType/* default.external */.Z.external:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLinkMapper, {
                productCategory: productCategory,
                path: productCategory.externalLink,
                insurerIcon: productCategory.icon.insurer,
                categoryIcon: productCategory.icon.url
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageRetailCategoryCard, {
                isLoading: false,
                displayName: productCategory.displayName,
                insurerIcon: productCategory.icon.insurer,
                categoryIcon: productCategory.icon.url,
                labels: productCategory.labels
            }, productCategory.code);
    }
};
/* harmony default export */ var LandingPageRetailCategoryCard_LandingPageRetailCategoryCard = (LandingPageRetailCategoryCard);


/***/ }),

/***/ 87418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71230);
/* harmony import */ var antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60872);
/* harmony import */ var antd_lib_modal_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83663);
/* harmony import */ var src_styles_globals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60082);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55267);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  p,\n  div {\n    font-size: 21px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 12px;\n  }\n  .ant-modal-header {\n    border-radius: 12px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 56px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Title).attrs({
    level: 5
}).withConfig({
    componentId: "sc-71c20da4-0"
})(_templateObject(), src_styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.charcoal10 */ .$.charcoal10);
var Body = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-71c20da4-1"
})(_templateObject1(), src_styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.charcoal10 */ .$.charcoal10);
var ButtonGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71c20da4-2"
})(_templateObject2());
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    fullWidth: true
}).withConfig({
    componentId: "sc-71c20da4-3"
})(_templateObject3());
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd_lib_modal_Modal__WEBPACK_IMPORTED_MODULE_6__["default"]).withConfig({
    componentId: "sc-71c20da4-4"
})(_templateObject4());
var Image = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-71c20da4-5"
})(_templateObject5());
var ErrorDialog = function(param) {
    var title = param.title, description = param.description, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, _errorButtons = param.errorButtons, errorButtons = _errorButtons === void 0 ? [] : _errorButtons, icon = param.icon;
    var sm = (0,antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().sm;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Modal, {
        width: sm ? "303px" : "auto",
        visible: isVisible,
        footer: null,
        closable: false,
        "data-testid": "error-dialog-modal",
        "data-gtm-input-code": "error-dialog-modal",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                justify: "center",
                children: icon || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
                    src: "/static/common/x-circle.svg"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Body, {
                children: description
            }),
            errorButtons.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonGroup, {
                children: errorButtons.map(function(param, index) {
                    var text = param.text, onClick = param.onClick, _type = param.type, type = _type === void 0 ? "primary" : _type;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                        "data-testid": "error-dialog-button-".concat(index),
                        "data-gtm-input-code": "error-dialog-button-".concat(index),
                        onClick: onClick,
                        type: type,
                        children: text
                    }, text);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorDialog);


/***/ }),

/***/ 69612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _LinkBody__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9638);
/* eslint-disable jsx-a11y/anchor-is-valid */ 


var Link = function(param) {
    var href = param.href, children = param.children, _target = param.target, target = _target === void 0 ? "#!" : _target;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            target: target,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkBody__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                level: 7,
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 9638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline;\n  color: var(--ui-form-button-text-enabled-text-color);\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ui-form-button-text-hover-text-color);\n    text-decoration: var(--ui-form-button-text-hover-text-decoration);\n    text-decoration-color: var(--ui-form-button-text-hover-text-color);\n    font-weight: var(--ui-form-button-text-hover-text-decoration);\n  }\n  &:focus {\n    color: var(--ui-form-button-text-focused-text-color);\n    text-decoration: var(--ui-form-button-text-focused-text-decoration);\n    text-decoration-color: var(--ui-form-button-text-focused-text-color);\n    font-weight: var(--ui-form-button-text-hover-text-decoration);\n  }\n  &:disabled {\n    color: var(--ui-form-button-text-disabled-text-color);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var LinkBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Body).withConfig({
    componentId: "sc-69ab8047-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (LinkBody);


/***/ }),

/***/ 35342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15746);
/* harmony import */ var antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60872);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94698);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styled_breakpoints__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_globals__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60082);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  ",
        " {\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  position: relative;\n  text-align: start;\n  z-index: 1;\n  line-height: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: var(--content-max-width);\n  margin: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px 0px 16px 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








var CustomImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("img").withConfig({
    componentId: "sc-55534223-0"
})(_templateObject(), function(props) {
    return props.height || "auto";
}, (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_3__.down)("lg"), function(props) {
    return props.mobileHeight || "auto";
});
var Headline = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Headline).withConfig({
    componentId: "sc-55534223-1"
})(_templateObject1(), function(props) {
    return props.textColor;
}, function(props) {
    return props.lineHeight;
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-55534223-2"
})(_templateObject2());
var BannerRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-55534223-3"
})(_templateObject3());
var TitleContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-55534223-4"
})(_templateObject4());
var TitleHeader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-55534223-5"
})(_templateObject5());
var EntryFormBanner = function(param) {
    var title = param.title, desktopImage = param.desktopImage, mobileImage = param.mobileImage, content = param.content;
    var ref, ref1;
    var ref2 = (0,antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(), md = ref2.md, xl = ref2.xl;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var locale = router.locale;
    var styles = {
        banner: {
            backgroundColor: content.categoryBanner.bgColor,
            maxHeight: "184px"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        style: styles.banner,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BannerRow, {
                align: "middle",
                wrap: false,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        flex: "auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleHeader, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleContainer, {
                                children: !xl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Headline, {
                                    "data-testid": "title-entry-form-banner",
                                    "data-gtm-input-code": "title-entry-form-banner",
                                    level: 7,
                                    textColor: (content === null || content === void 0 ? void 0 : (ref = content.categoryBanner) === null || ref === void 0 ? void 0 : ref.titleColor) || _styles_globals__WEBPACK_IMPORTED_MODULE_9__/* .color.charcoal10 */ .$.charcoal10,
                                    lineHeight: "24px",
                                    children: title === null || title === void 0 ? void 0 : title[locale]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Headline, {
                                    "data-testid": "title-entry-form-banner",
                                    "data-gtm-input-code": "title-entry-form-banner",
                                    level: 2,
                                    textColor: (content === null || content === void 0 ? void 0 : (ref1 = content.categoryBanner) === null || ref1 === void 0 ? void 0 : ref1.titleColor) || _styles_globals__WEBPACK_IMPORTED_MODULE_9__/* .color.charcoal10 */ .$.charcoal10,
                                    lineHeight: "42px",
                                    children: title === null || title === void 0 ? void 0 : title[locale]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        flex: !xl ? "140px" : "790px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            justify: "end",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomImage, {
                                "data-testid": "img-entry-form-banner",
                                "data-gtm-input-code": "img-entry-form-banner",
                                src: !md ? mobileImage : desktopImage,
                                alt: "entry-form-banner",
                                mobileHeight: "136px",
                                height: "184px"
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (EntryFormBanner);


/***/ }),

/***/ 95040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35865);
/* harmony import */ var sunday_component_node_modules_antd__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9117);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66934);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60872);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94698);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(styled_breakpoints__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _styles_globals__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60082);
/* harmony import */ var _constants_input__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54444);
/* harmony import */ var _constants_entryForm__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(18643);
/* harmony import */ var _utils_validationRules__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(95416);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63049);
/* harmony import */ var _constants_format__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71512);
/* harmony import */ var _Common_Button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(55267);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  top: 0;\n  margin: 0px;\n  padding: 0px;\n  max-width: 100vw;\n  .ant-modal-header {\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .ant-modal-body {\n    padding: 0px;\n  }\n  .ant-modal-footer {\n    padding: 16px;\n  }\n  .ant-modal-content {\n    border-radius: 16px;\n  }\n  .ant-scrolling-effect {\n    width: 0px;\n  }\n  ",
        " {\n    .ant-modal,\n    .ant-modal-content {\n      height: 100vh;\n      max-width: 100vw;\n      margin: 0px;\n      top: 0;\n      padding: 0px;\n    }\n    .ant-modal-body {\n      height: calc(100vh - 173px);\n      width: 100vw;\n      overflow: auto;\n    }\n    .ant-modal-footer {\n      padding: 16px 16px 32px 16px;\n      position: fixed;\n      bottom: 0;\n      width: 100%;\n      background: white;\n    }\n    .ant-modal-content {\n      overflow: auto;\n      border-radius: 0px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var HealthBasicEntryForm = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(2601), __webpack_require__.e(6086)]).then(__webpack_require__.bind(__webpack_require__, 46086));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46086)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {});
    }
});
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_3__.Title).withConfig({
    componentId: "sc-ba1dd209-0"
})(_templateObject(), _styles_globals__WEBPACK_IMPORTED_MODULE_8__/* .color.charcoal10 */ .$.charcoal10);
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ba1dd209-1"
})(_templateObject1(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_4__.down)("md"));
var EntryFormModal = function(param) {
    var entryFormCode = param.entryFormCode, _activeInputCodes = param.activeInputCodes, activeInputCodes = _activeInputCodes === void 0 ? [] : _activeInputCodes, visible = param.visible, _setVisible = param.setVisible, setVisible = _setVisible === void 0 ? function() {} : _setVisible, initialValues = param.initialValues, titleText = param.titleText, headerText = param.headerText, buttonText = param.buttonText, _isInitialValuesValidate = param.isInitialValuesValidate, isInitialValuesValidate = _isInitialValuesValidate === void 0 ? false : _isInitialValuesValidate, onSubmit = param.onSubmit, _leadEnabled = param.leadEnabled, leadEnabled = _leadEnabled === void 0 ? false : _leadEnabled, _leadDefaultSelected = param.leadDefaultSelected, leadDefaultSelected = _leadDefaultSelected === void 0 ? false : _leadDefaultSelected;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("plan-page").t;
    var lg = (0,antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().lg;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(sunday_component_node_modules_antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].useForm */ .Z.useForm(), 1), form = ref[0];
    // loading state
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    // submit state
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isSubmitted = ref2[0], setIsSubmitted = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (isInitialValuesValidate) {
            var inputValidationResult = (0,_utils_validationRules__WEBPACK_IMPORTED_MODULE_13__/* .validateValueByActiveInputCode */ .KK)(activeInputCodes, initialValues);
            // show entry form when there're error field
            var inputErrors = inputValidationResult.filter(function(validationResult) {
                return validationResult.isError;
            });
            if (inputErrors.length > 0) {
                setVisible(true);
                setIsSubmitted(true);
            } else {
                // map active input codes to input field name.
                var inputValue = {
                    effectiveDate: null,
                    insuredDateOfBirth: null,
                    insuredGender: null
                };
                activeInputCodes.forEach(function(activeInputCode) {
                    switch(activeInputCode.inputCode){
                        case _constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.EFFECTIVE_DATE */ .L.EFFECTIVE_DATE:
                            var ref, ref1;
                            inputValue.effectiveDate = (initialValues === null || initialValues === void 0 ? void 0 : (ref = initialValues.effectiveDate) === null || ref === void 0 ? void 0 : ref.isValid()) ? initialValues === null || initialValues === void 0 ? void 0 : (ref1 = initialValues.effectiveDate) === null || ref1 === void 0 ? void 0 : ref1.format("YYYY-MM-DD") : null;
                            break;
                        case _constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.INSURED_DATE_OF_BIRTH */ .L.INSURED_DATE_OF_BIRTH:
                            var ref2, ref3;
                            inputValue.insuredDateOfBirth = (initialValues === null || initialValues === void 0 ? void 0 : (ref2 = initialValues.insuredDateOfBirth) === null || ref2 === void 0 ? void 0 : ref2.isValid()) ? initialValues === null || initialValues === void 0 ? void 0 : (ref3 = initialValues.insuredDateOfBirth) === null || ref3 === void 0 ? void 0 : ref3.format("YYYY-MM-DD") : null;
                            break;
                        case _constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.INSURED_GENDER */ .L.INSURED_GENDER:
                            inputValue.insuredGender = (initialValues === null || initialValues === void 0 ? void 0 : initialValues.insuredGender) || null;
                            break;
                    }
                });
                onSubmit(inputValue);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var styles = {
        form: {
            paddingBottom: "16px"
        }
    };
    var handleButtonSubmit = function() {
        setIsLoading(true);
        setIsSubmitted(true);
        form.submit();
    };
    var onFormFinishSuccess = function() {
        // map active input codes to input field name.
        var inputValue = {
            effectiveDate: form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.EFFECTIVE_DATE */ .L.EFFECTIVE_DATE) || null,
            insuredDateOfBirth: form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.INSURED_DATE_OF_BIRTH */ .L.INSURED_DATE_OF_BIRTH) || null,
            insuredGender: form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.INSURED_GENDER */ .L.INSURED_GENDER) || null
        };
        var inputValidationResult = (0,_utils_validationRules__WEBPACK_IMPORTED_MODULE_13__/* .validateValueByActiveInputCode */ .KK)(activeInputCodes, inputValue);
        // show entry form when there're error field
        var inputErrors = inputValidationResult.filter(function(validationResult) {
            return validationResult.isError;
        });
        if (inputErrors.length === 0) {
            var entryFormInputValue = {
                effectiveDate: null,
                insuredDateOfBirth: null,
                insuredGender: null,
                leadRequest: form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.LEAD_REQUEST */ .L.LEAD_REQUEST) || false,
                fullName: form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.FULL_NAME */ .L.FULL_NAME) || null,
                mobileNumber: form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.MOBILE_NUMBER */ .L.MOBILE_NUMBER) || null
            };
            activeInputCodes.forEach(function(activeInputCode) {
                switch(activeInputCode.inputCode){
                    case _constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.EFFECTIVE_DATE */ .L.EFFECTIVE_DATE:
                        var ref;
                        entryFormInputValue.effectiveDate = ((ref = form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.EFFECTIVE_DATE */ .L.EFFECTIVE_DATE)) === null || ref === void 0 ? void 0 : ref.isValid()) ? (0,_utils_date__WEBPACK_IMPORTED_MODULE_15__/* .formatDateText */ .Kb)(form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.EFFECTIVE_DATE */ .L.EFFECTIVE_DATE), _constants_format__WEBPACK_IMPORTED_MODULE_16__/* .DATE_INPUT_TEXT_FORMAT */ .AV) : null;
                        break;
                    case _constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.INSURED_DATE_OF_BIRTH */ .L.INSURED_DATE_OF_BIRTH:
                        var ref1;
                        entryFormInputValue.insuredDateOfBirth = ((ref1 = form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.INSURED_DATE_OF_BIRTH */ .L.INSURED_DATE_OF_BIRTH)) === null || ref1 === void 0 ? void 0 : ref1.isValid()) ? (0,_utils_date__WEBPACK_IMPORTED_MODULE_15__/* .formatDateText */ .Kb)(form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.INSURED_DATE_OF_BIRTH */ .L.INSURED_DATE_OF_BIRTH), _constants_format__WEBPACK_IMPORTED_MODULE_16__/* .DATE_INPUT_TEXT_FORMAT */ .AV) : null;
                        break;
                    case _constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.INSURED_GENDER */ .L.INSURED_GENDER:
                        entryFormInputValue.insuredGender = form.getFieldValue(_constants_input__WEBPACK_IMPORTED_MODULE_14__/* .INPUT_CODE.INSURED_GENDER */ .L.INSURED_GENDER) || null;
                        break;
                }
            });
            setVisible(false);
            onSubmit(entryFormInputValue);
        }
        setIsLoading(false);
        setIsSubmitted(false);
    };
    var onFormFinishFailed = function() {
        setIsLoading(false);
        setIsSubmitted(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Modal, {
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
            level: 5,
            style: {
                textAlign: "center"
            },
            children: headerText || t("coverageDetail.title")
        }),
        footer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Common_Button__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            htmlType: "submit",
            "data-cy": "entry-form.submit-button",
            loading: isLoading,
            onClick: handleButtonSubmit,
            block: true,
            children: buttonText || t("coverageDetail.formButton")
        }),
        visible: visible,
        onCancel: function() {
            setVisible(false);
        },
        width: lg ? 444 : "100vw",
        maskClosable: false,
        centered: !!lg,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            style: styles.form,
            children: [
                titleText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: titleText
                }),
                entryFormCode === _constants_entryForm__WEBPACK_IMPORTED_MODULE_18__/* .ENTRY_FORM_CODE.HEALTH_BASIC_ENTRY_FORM */ .K.HEALTH_BASIC_ENTRY_FORM && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HealthBasicEntryForm, {
                    form: form,
                    activeInputCodes: activeInputCodes,
                    initialValues: initialValues,
                    onFormFinishSuccess: onFormFinishSuccess,
                    onFormFinishFailed: onFormFinishFailed,
                    isLoading: isLoading,
                    isSubmitted: isSubmitted,
                    leadEnabled: leadEnabled,
                    leadDefaultSelected: leadDefaultSelected
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EntryFormModal);


/***/ }),

/***/ 20206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NotFoundDirectLinkError_NotFoundDirectLinkError; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(66934);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(65934);
// EXTERNAL MODULE: ./src/components/Common/Link.tsx
var Link = __webpack_require__(69612);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Button = __webpack_require__(55267);
;// CONCATENATED MODULE: ./src/components/PlanContentDirectLinkPage/NotFoundDirectLinkError/NotFoundDirectLinkError.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 120px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin: 40px 0px 0px 0px;\n    width: 200px;\n    height: 200px;\n  }\n  width: 324px;\n  height: 324px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 613px;\n  margin: 120px 0px 40px 0px;\n  padding: 16px 16px 0px 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 40px 24px 40px 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin: 40px 24px 60px 24px;\n  }\n  margin: 40px 16px 80px 16px;\n  width: 100%;\n  max-width: 372px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-left: 20px;\n  margin: 0px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}






var DesktopErrorImageContainer = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-373ca176-0"
})(_templateObject());
var ErrorImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-373ca176-1"
})(_templateObject1(), (0,styled_breakpoints.down)("sm"));
var ErrorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-373ca176-2"
})(_templateObject2());
var ErrorMobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-373ca176-3"
})(_templateObject3());
var ErrorTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Hero).attrs({
    level: 4
}).withConfig({
    componentId: "sc-373ca176-4"
})(_templateObject4(), globals/* color.charcoal10 */.$.charcoal10);
var ErrorMobileTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Headline).attrs({
    level: 2
}).withConfig({
    componentId: "sc-373ca176-5"
})(_templateObject5(), globals/* color.charcoal10 */.$.charcoal10);
var ListItemBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-373ca176-6"
})(_templateObject6(), globals/* color.charcoal09 */.$.charcoal09);
var EntryFormButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-373ca176-7"
})(_templateObject7());
var PlanButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-373ca176-8"
})(_templateObject8());
var ButtonText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-373ca176-9"
})(_templateObject9());
var ButtonSectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-373ca176-10"
})(_templateObject10(), (0,styled_breakpoints.down)("md"));
var UnorderList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-373ca176-11"
})(_templateObject11());

;// CONCATENATED MODULE: ./src/components/PlanContentDirectLinkPage/NotFoundDirectLinkError/NotFoundDirectLinkError.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 







var NotFoundDirectLinkError = function(param) {
    var _onOpenEntryForm = param.onOpenEntryForm, onOpenEntryForm = _onOpenEntryForm === void 0 ? function() {} : _onOpenEntryForm, _onGoToPlanPage = param.onGoToPlanPage, onGoToPlanPage = _onGoToPlanPage === void 0 ? function() {} : _onGoToPlanPage, channelPath = param.channelPath;
    var lg = (0,useBreakpoint/* default */.Z)().lg;
    var t = (0,esm/* useTranslation */.$G)("plan-content-direct-link").t;
    var ref = (0,react.useState)(false), isLoadingGoToPlan = ref[0], setIsLoadingGoToPlan = ref[1];
    var onClickOpenEntryForm = function() {
        onOpenEntryForm();
    };
    var onClickGoToPlanPage = function() {
        setIsLoadingGoToPlan(true);
        onGoToPlanPage();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: lg ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
            justify: "center",
            gutter: [
                40,
                0
            ],
            align: "top",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopErrorImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorImage, {
                        width: 324,
                        height: 324,
                        alt: "",
                        src: "/static/pages/planContentDirectLink/not-match-error.svg"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitle, {
                                    children: t("errorPage.searchNotFound.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnorderList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemBody, {
                                                children: t("errorPage.searchNotFound.detail1")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemBody, {
                                                children: [
                                                    t("errorPage.searchNotFound.detail2"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath)),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "",
                                                            children: t("errorPage.searchNotFound.detail2Link")
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemBody, {
                                                children: [
                                                    t("errorPage.searchNotFound.detail3"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "tel:+6620263355",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "",
                                                            children: t("errorPage.searchNotFound.detail3Link")
                                                        })
                                                    }),
                                                    t("errorPage.searchNotFound.detail3Tail")
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSectionContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryFormButton, {
                                    "data-testid": "open-entry-form-button",
                                    "data-gtm-input-code": "open-entry-form-button",
                                    fullWidth: true,
                                    onClick: onClickOpenEntryForm,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                                        children: t("errorPage.searchNotFound.openEntryForm")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanButton, {
                                    "data-testid": "go-to-plan-button",
                                    "data-gtm-input-code": "go-to-plan-button",
                                    fullWidth: true,
                                    onClick: onClickGoToPlanPage,
                                    loading: isLoadingGoToPlan,
                                    type: "outlined",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                                        children: t("errorPage.searchNotFound.goToPlanButton")
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
            justify: "center",
            align: "middle",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        justify: "center",
                        align: "middle",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorImage, {
                            width: 200,
                            height: 200,
                            alt: "",
                            src: "/static/pages/planContentDirectLink/not-match-error.svg"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        justify: "center",
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorMobileContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMobileTitle, {
                                        children: t("errorPage.searchNotFound.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnorderList, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemBody, {
                                                    children: t("errorPage.searchNotFound.detail1")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemBody, {
                                                    children: [
                                                        t("errorPage.searchNotFound.detail2"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath)),
                                                            target: "",
                                                            children: t("errorPage.searchNotFound.detail2Link")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemBody, {
                                                    children: [
                                                        t("errorPage.searchNotFound.detail3"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath)),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: "",
                                                                children: t("errorPage.searchNotFound.detail3Link")
                                                            })
                                                        }),
                                                        t("errorPage.searchNotFound.detail3Tail")
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSectionContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryFormButton, {
                                        "data-testid": "open-entry-form-button",
                                        "data-gtm-input-code": "open-entry-form-button",
                                        fullWidth: true,
                                        onClick: onClickOpenEntryForm,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                                            children: t("errorPage.searchNotFound.openEntryForm")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanButton, {
                                        "data-testid": "go-to-plan-button",
                                        "data-gtm-input-code": "go-to-plan-button",
                                        fullWidth: true,
                                        onClick: onClickGoToPlanPage,
                                        loading: isLoadingGoToPlan,
                                        type: "outlined",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                                            children: t("errorPage.searchNotFound.goToPlanButton")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var NotFoundDirectLinkError_NotFoundDirectLinkError = (NotFoundDirectLinkError);


/***/ }),

/***/ 53883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PlanContentDirectLinkPage_OtherPlanBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(66934);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Button = __webpack_require__(55267);
;// CONCATENATED MODULE: ./src/components/Common/Icons/ArrowRightIcon.tsx

var ArrowRightIcon = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "25",
            height: "24",
            viewBox: "0 0 ".concat(width, " ").concat(height),
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.5 12H19.5",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.5 5L19.5 12L12.5 19",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
/* harmony default export */ var Icons_ArrowRightIcon = (ArrowRightIcon);

;// CONCATENATED MODULE: ./src/components/PlanContentDirectLinkPage/OtherPlanBanner.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 938px;\n  margin: auto;\n  padding: ",
        ";\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: start;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: start;\n  margin-bottom: 40px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  margin-bottom: 40px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 330px;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  vertical-align: middle;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 256px;\n  position: relative;\n  ",
        " {\n    height: 178px;\n    margin-bottom: 40px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}












var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c693a61c-0"
})(_templateObject(), function(props) {
    return props.bgColor;
});
var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c693a61c-1"
})(_templateObject1(), function(props) {
    return props.isFullSize ? "80px 16px 80px 16px" : "80px 16px 0px 16px";
}, (0,styled_breakpoints.down)("lg"), function(props) {
    return props.isFullSize ? "80px 16px 80px 16px" : "80px 16px 0px 16px";
});
var TitleDesktop = (0,styled_components_browser_esm/* default */.ZP)(lib.Hero).withConfig({
    componentId: "sc-c693a61c-2"
})(_templateObject2(), function(props) {
    return props.titleColor;
});
var TitleMobile = (0,styled_components_browser_esm/* default */.ZP)(lib.Headline).withConfig({
    componentId: "sc-c693a61c-3"
})(_templateObject3(), function(props) {
    return props.titleColor;
});
var DescriptionDesktop = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-c693a61c-4"
})(_templateObject4(), function(props) {
    return props.contentColor;
});
var DescriptionMobile = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-c693a61c-5"
})(_templateObject5(), function(props) {
    return props.contentColor;
});
var ButtonText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-c693a61c-6"
})(_templateObject6());
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c693a61c-7"
})(_templateObject7(), (0,styled_breakpoints.down)("md"));
var ArrowLogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c693a61c-8"
})(_templateObject8());
// DEV-NOTE: use position relative for Image layout=fill.
// ref: https://nextjs.org/docs/api-reference/next/image#fill
var BannerImageLogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c693a61c-9"
})(_templateObject9(), (0,styled_breakpoints.down)("md"));
var OtherPlanBanner = function(param) {
    var imageUrl = param.imageUrl, title = param.title, description = param.description, bgColor = param.bgColor, isFullSize = param.isFullSize, _onSeeOtherPlans = param.onSeeOtherPlans, onSeeOtherPlans = _onSeeOtherPlans === void 0 ? function() {} : _onSeeOtherPlans, titleColor = param.titleColor, contentColor = param.contentColor;
    var locale = (0,router.useRouter)().locale;
    var lg = (0,useBreakpoint/* default */.Z)().lg;
    var t = (0,esm/* useTranslation */.$G)("plan-content-direct-link").t;
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var handleSeeOtherPlans = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        return [
                            4,
                            onSeeOtherPlans()
                        ];
                    case 1:
                        _state.sent();
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSeeOtherPlans() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        bgColor: bgColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
            isFullSize: isFullSize,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                align: "bottom",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        xl: 12,
                        lg: 12,
                        md: 24,
                        sm: 24,
                        xs: 24,
                        order: lg ? 1 : 2,
                        children: lg ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDesktop, {
                                    level: 4,
                                    titleColor: titleColor,
                                    children: title[locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionDesktop, {
                                    level: 5,
                                    contentColor: contentColor,
                                    children: description[locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        "data-testid": "see-other-plan-button",
                                        "data-gtm-input-code": "see-other-plan-button",
                                        fullWidth: true,
                                        onClick: handleSeeOtherPlans,
                                        loading: isLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonText, {
                                            level: 7,
                                            children: [
                                                t("otherPlanBanner.button"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLogoContainer, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightIcon, {
                                                        width: 24,
                                                        height: 24
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleMobile, {
                                    level: 3,
                                    titleColor: titleColor,
                                    children: title[locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionMobile, {
                                    level: 7,
                                    contentColor: contentColor,
                                    children: description[locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        "data-testid": "see-other-plan-button",
                                        "data-gtm-input-code": "see-other-plan-button",
                                        fullWidth: true,
                                        onClick: onSeeOtherPlans,
                                        loading: isLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonText, {
                                            level: 7,
                                            children: [
                                                t("otherPlanBanner.button"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLogoContainer, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightIcon, {
                                                        width: 24,
                                                        height: 24
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        xl: 12,
                        lg: 12,
                        md: 24,
                        sm: 24,
                        xs: 24,
                        order: lg ? 2 : 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImageLogoContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: imageUrl,
                                layout: "fill"
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var PlanContentDirectLinkPage_OtherPlanBanner = (OtherPlanBanner);


/***/ }),

/***/ 98310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15746);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94698);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CategoryCard_LandingPageRetailCategoryCard_LandingPageRetailCategoryCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26331);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    display: none;\n  }\n  text-align: center;\n  margin-bottom: 40px;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    display: none;\n  }\n  font-size: 24px;\n  margin-top: 24px;\n  text-align: center;\n  margin-bottom: 40px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: var(--content-max-width);\n  margin: auto;\n  display: grid;\n  grid-gap: 24px 16px;\n  justify-content: center;\n  padding: initial;\n  ",
        " {\n    grid-template-columns: repeat(1, 1fr);\n    grid-gap: 16px 16px;\n  }\n  ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  ",
        " {\n    grid-template-columns: repeat(4, 1fr);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    background: ",
        ";\n    padding: 40px 16px 80px 16px;\n    border: initial;\n    box-shadow: initial;\n    border-radius: initial;\n    max-width: 938px;\n  }\n  margin: auto;\n  padding: 80px 58px 80px 58px;\n  background: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fb10a074-0"
})(_templateObject());
var TitleDesktop = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_3__.Headline).withConfig({
    componentId: "sc-fb10a074-1"
})(_templateObject1(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("md"), function(props) {
    return props.titleColor;
});
var TitleMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_3__.Headline).withConfig({
    componentId: "sc-fb10a074-2"
})(_templateObject2(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.up)("lg"), function(props) {
    return props.titleColor;
});
var ProductContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb10a074-3"
})(_templateObject3(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("sm"), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.up)("md"), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.up)("lg"), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.up)("xl"));
var ProductCategoryContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb10a074-4"
})(_templateObject4(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("md"), function(props) {
    return props.bgColor;
}, function(props) {
    return props.bgColor;
});
var ProductList = function(param) {
    var isLoading = param.isLoading, productCategories = param.productCategories, channelPath = param.channelPath, content = param.content, isRET = param.isRET;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            span: 24,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ProductCategoryContainer, {
                bgColor: (ref = content.directlink) === null || ref === void 0 ? void 0 : (ref1 = ref.otherCategories) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.background) === null || ref2 === void 0 ? void 0 : ref2.color,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: {
                            span: 24
                        },
                        md: {
                            span: 20,
                            offset: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleDesktop, {
                                level: 2,
                                titleColor: (ref3 = content.directlink) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.otherCategories) === null || ref4 === void 0 ? void 0 : ref4.titleTextColor,
                                children: content.directlink.otherCategories.title[locale]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleMobile, {
                                level: 4,
                                titleColor: (ref5 = content.directlink) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.otherCategories) === null || ref6 === void 0 ? void 0 : ref6.titleTextColor,
                                children: content.directlink.otherCategories.title[locale]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        span: 24,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProductContainer, {
                            children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_CategoryCard_LandingPageRetailCategoryCard_LandingPageRetailCategoryCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        isLoading: true
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_CategoryCard_LandingPageRetailCategoryCard_LandingPageRetailCategoryCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        isLoading: true
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_CategoryCard_LandingPageRetailCategoryCard_LandingPageRetailCategoryCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        isLoading: true
                                    })
                                ]
                            }) : productCategories.map(function(productCategory) {
                                return (0,_CategoryCard_LandingPageRetailCategoryCard_LandingPageRetailCategoryCard__WEBPACK_IMPORTED_MODULE_8__/* .getLandingPageRetailProductCategoryCard */ .y)({
                                    productCategory: productCategory,
                                    channelPath: channelPath
                                });
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductList);


/***/ }),

/***/ 25194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ SpecialBenefitSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15746);
/* harmony import */ var antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60872);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66934);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_4__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  margin-top: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 60px;\n  width: 60px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Container = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be45743a-0"
})(_templateObject());
var SpecialBenefitCardLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-be45743a-1"
})(_templateObject1());
var IconImg = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-be45743a-2"
})(_templateObject2());
var SpecialBenefitSection = function(param) {
    var specialBenefitItems = param.specialBenefitItems, insurerPlanCode = param.insurerPlanCode;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("plan").t;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var lg = (0,antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().lg;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                justify: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Title, {
                    level: lg ? 3 : 2,
                    children: t("planCard.highlights")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                justify: "center",
                gutter: [
                    16,
                    16
                ],
                children: [
                    specialBenefitItems.length === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_4__.Overline, {
                        children: t("planCard.noSpecialBenefit")
                    }),
                    specialBenefitItems.map(function(specialBenefit) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            span: 12,
                            md: 8,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    justify: "center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconImg, {
                                        "data-cy": "plan-page.plan-card.".concat(insurerPlanCode, ".highlight.").concat(specialBenefit.code, ".img}"),
                                        src: specialBenefit.icon.url,
                                        alt: specialBenefit.icon.title
                                    }, specialBenefit.icon.code)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SpecialBenefitCardLabel, {
                                    "data-cy": "plan-page.plan-card.".concat(insurerPlanCode, ".highlight.").concat(specialBenefit.code, ".label}"),
                                    children: specialBenefit.displayName[locale]
                                })
                            ]
                        }, specialBenefit.code);
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 18643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ENTRY_FORM_CODE; },
/* harmony export */   "_": function() { return /* binding */ ENTRY_FORM_INPUT_CODE; }
/* harmony export */ });
var ENTRY_FORM_CODE = {
    HEALTH_BASIC_ENTRY_FORM: "health-basic-entry-form",
    MOTOR_BASIC_ENTRY_FORM: "motor-basic-entry-form",
    HEALTH_REVISED_CONTENT_ENTRY_FORM: "health-revised-content-entry-form"
};
var ENTRY_FORM_INPUT_CODE = {
    EFFECTIVE_DATE: "effectiveDate",
    INSURED_DATE_OF_BIRTH: "insuredDateOfBirth",
    INSURED_GENDER: "insuredGender",
    INSURED_MARITAL_STATUS: "maritalStatus"
};


/***/ }),

/***/ 74092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ERROR_CODE; },
/* harmony export */   "b": function() { return /* binding */ BUSINESS_ERROR_CODE; }
/* harmony export */ });
// code for general error.
var ERROR_CODE = {
    // validation fail or input invalid.
    VALIDATION_ERROR: "GVE0001",
    // internal error.
    TECHNICAL_ERROR: "TE00001",
    // authentication error.
    AUTHENTICATION_ERROR: "AE00001"
};
// code for business error.
var BUSINESS_ERROR_CODE = {
    // attempt to find but not found
    NOT_FOUND: "BE00001",
    // expired or not active item.
    EXPIRED: "BE00002",
    // doesn't matched the given condition.
    NOT_MATCHED_WITH_CONDITION: "BE00003",
    // failed in amlo checking
    AMLO_ERROR: "BE00004",
    // pricing changed or invalid
    PRICING_INVALID: "BE00005",
    // coupon error
    COUPON_ERROR: "BE00006",
    // status is invalid to process, status is invalid
    STATUS_INVALID: "BE00007",
    // status is invalid to process, status is already cancel
    STATUS_CANCEL: "BE00008",
    // status is invalid to process, status is already paid
    STATUS_PAID: "BE00009",
    STATUS_RENEWED: "BE00010",
    // status is invalid to process, status is already reject
    STATUS_REJECT: "BE00011",
    // verify is invalid
    VERIFY_NOT_VALID: "BE00014",
    // data is duplicate
    DUPLICATE: "BE00015"
};


/***/ }),

/***/ 62090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QQ": function() { return /* binding */ MOTOR_INSURED_FORM_PARAMS; },
/* harmony export */   "Vs": function() { return /* binding */ ENTRY_FORM_PARAMS; },
/* harmony export */   "Yz": function() { return /* binding */ UTM_PARAMS; },
/* harmony export */   "gH": function() { return /* binding */ CAR_INFO_ENTRY_FORM_PARAMS; },
/* harmony export */   "g_": function() { return /* binding */ GLOBAL_PARAMS; },
/* harmony export */   "lF": function() { return /* binding */ IS_DIRECTED; },
/* harmony export */   "qh": function() { return /* binding */ GLOBAL_PARAMS_FOR_RENEWAL; },
/* harmony export */   "zP": function() { return /* binding */ S_REF_CODE; }
/* harmony export */ });
/* unused harmony exports UTM_PARAMS_LIST, POLICY_INFO_PARAMS */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
/* eslint-disable import/prefer-default-export */ 
var UTM_PARAMS = {
    UTM_SOURCE: "utm_source",
    UTM_MEDIUM: "utm_medium",
    UTM_CAMPAIGN: "utm_campaign",
    UTM_TERM: "utm_term",
    UTM_CONTENT: "utm_content"
};
var UTM_PARAMS_LIST = [
    UTM_PARAMS.UTM_SOURCE,
    UTM_PARAMS.UTM_MEDIUM,
    UTM_PARAMS.UTM_CAMPAIGN,
    UTM_PARAMS.UTM_TERM,
    UTM_PARAMS.UTM_CONTENT, 
];
var S_REF_CODE = "sRefCode";
var GLOBAL_PARAMS = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UTM_PARAMS_LIST).concat([
    S_REF_CODE,
    "apTraceId",
    "crmSfId", 
]);
var GLOBAL_PARAMS_FOR_RENEWAL = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UTM_PARAMS_LIST).concat([
    S_REF_CODE,
    "apTraceId",
    "renewalCode", 
]);
var ENTRY_FORM_PARAMS = [
    "insuredDateOfBirth",
    "effectiveDate",
    "insuredGender",
    "maritalStatus", 
];
var CAR_INFO_ENTRY_FORM_PARAMS = [
    "carMake",
    "recommendItems",
    "carYear",
    "carModel",
    "carTrim",
    "purpose", 
];
var MOTOR_INSURED_FORM_PARAMS = [
    "insuredDateOfBirth",
    "zipcode"
];
var POLICY_INFO_PARAMS = (/* unused pure expression or super */ null && ([
    "purpose",
    "isWhiteLicensePlate",
    "effectiveDate",
    "interestedPolicyType", 
]));
var IS_DIRECTED = "isDirected";


/***/ }),

/***/ 61956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ COVERAGE_DETAIL_TEMPLATE_OPTION; },
/* harmony export */   "Q": function() { return /* binding */ PLAN_CARD_TEMPLATE_OPTION; }
/* harmony export */ });
var PLAN_CARD_TEMPLATE_OPTION = {
    A: "A",
    B: "B"
};
var COVERAGE_DETAIL_TEMPLATE_OPTION = {
    A: "A",
    B: "B"
};


/***/ }),

/***/ 64615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ge": function() { return /* binding */ ValueType; },
/* harmony export */   "gq": function() { return /* binding */ AvailableValuesType; },
/* harmony export */   "yl": function() { return /* binding */ CoverageType; }
/* harmony export */ });
/* unused harmony export FavorableValueType */
var FavorableValueType;
(function(FavorableValueType) {
    FavorableValueType["greater"] = "greater";
    FavorableValueType["lesser"] = "lesser";
    FavorableValueType["true"] = "true";
    FavorableValueType["false"] = "false";
    FavorableValueType["null"] = "null";
})(FavorableValueType || (FavorableValueType = {}));
var ValueType;
(function(ValueType) {
    ValueType["integer"] = "integer";
    ValueType["boolean"] = "boolean";
    ValueType["number"] = "number";
    ValueType["string"] = "string";
})(ValueType || (ValueType = {}));
var AvailableValuesType;
(function(AvailableValuesType) {
    AvailableValuesType["GMD_CODE"] = "GMD_CODE";
    AvailableValuesType["FE_EMBEDDED"] = "FE_EMBEDDED";
    AvailableValuesType["PROVIDED"] = "PROVIDED";
    AvailableValuesType["GMD_PROVIDED"] = "GMD_PROVIDED";
})(AvailableValuesType || (AvailableValuesType = {}));
var CoverageType;
(function(CoverageType) {
    CoverageType["main"] = "main";
    CoverageType["other"] = "other";
    CoverageType["additional"] = "additional";
})(CoverageType || (CoverageType = {}));


/***/ }),

/***/ 80948:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var ProductTypes;
(function(ProductTypes) {
    ProductTypes["dynamic"] = "dynamic";
    ProductTypes["static"] = "static";
    ProductTypes["external"] = "external";
})(ProductTypes || (ProductTypes = {}));
/* harmony default export */ __webpack_exports__["Z"] = (ProductTypes);


/***/ }),

/***/ 41074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T3": function() { return /* binding */ utmCheckout; },
/* harmony export */   "i0": function() { return /* binding */ getSRefCode; }
/* harmony export */ });
/* unused harmony export formatUtmParams */
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85760);
/* harmony import */ var src_constants_params__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62090);





/**
 * Retrieves UTM parameters from cookies and returns them in a camelCase formatted object.
 *
 * @return {ReferenceType}
 */ var utmCheckout = function(channelPath) {
    var keyPrefix = src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_1__/* .LOGICAL_GROUP_CHANNEL_CODE */ .V === src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_1__/* .RETAIL_LOGICAL_GROUP_CHANNEL_CODE */ .b ? "utm_" : "".concat(channelPath, "_utm_");
    var utmSource = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)("".concat(keyPrefix, "source"));
    var utmMedium = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)("".concat(keyPrefix, "medium"));
    var utmCampaign = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)("".concat(keyPrefix, "campaign"));
    return {
        utmSource: utmSource,
        utmMedium: utmMedium,
        utmCampaign: utmCampaign
    };
};
var getSRefCode = function(channelPath) {
    var keyPrefix = src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_1__/* .LOGICAL_GROUP_CHANNEL_CODE */ .V === src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_1__/* .RETAIL_LOGICAL_GROUP_CHANNEL_CODE */ .b ? "" : "".concat(channelPath, "_");
    return (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)("".concat(keyPrefix).concat(src_constants_params__WEBPACK_IMPORTED_MODULE_2__/* .S_REF_CODE */ .zP));
};
/**
 * Formats the given object by converting the keys that start with "utm" to camel case.
 *
 * @param {object} obj - The object to be formatted.
 * @return {object} The formatted object with keys in camel case.
 */ var formatUtmParams = function(obj) {
    var formattedObject = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _sliced_to_array(_step.value, 2), key = _value[0], value = _value[1];
            if (key.startsWith("utm")) {
                var camelKey = snakeToCamelCase(key);
                formattedObject[camelKey] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formattedObject;
};


/***/ }),

/***/ 82833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vo": function() { return /* binding */ formatCurrencyLabelInArray; },
/* harmony export */   "dP": function() { return /* binding */ numberToThCurrencyWithoutSymbol; },
/* harmony export */   "en": function() { return /* binding */ formatCurrencyDecimal; },
/* harmony export */   "fe": function() { return /* binding */ numberToCurrency; }
/* harmony export */ });
/* unused harmony exports numberToThCurrency, numberToIdCurrency */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _constants_region__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7951);
/* eslint-disable import/prefer-default-export */ 


/**
 * convert number to THB  e.g. 100  => ฿100, 1000 => ฿1,000
 * @param number input number;
 * @returns   string of THB;
 */ var numberToThCurrency = function(number) {
    return new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: "THB",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(number);
};
/**
 * convert number to Rp  e.g. 100  => Rp100, 1000 => Rp1.000, 100.23 => Rp100,23
 * @param number input number;
 * @returns   string of Rp;
 */ var numberToIdCurrency = function(number) {
    return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(number).replace("Rp\xa0", "Rp");
};
/**
 * convert number to th currency without currency symbo e.g. 1,000,000.
 * @param number input number.
 * @param minimumIntegerDigits min number of display number unit.
 * @returns string of th currency.
 */ var numberToThCurrencyWithoutSymbol = function(number, minimumIntegerDigits) {
    return new Intl.NumberFormat("en-EN", {
        style: "decimal",
        minimumIntegerDigits: minimumIntegerDigits,
        minimumFractionDigits: 0
    }).format(number);
};
/**
 * convert number to currency base on region
 * @param number input number;
 * @returns   string of currency;
 */ var numberToCurrency = function(number) {
    switch(_constants_region__WEBPACK_IMPORTED_MODULE_0__/* .REGION */ .Xz){
        case _constants_region__WEBPACK_IMPORTED_MODULE_0__/* .REGION_OPTION.TH */ .Em.TH:
            return numberToThCurrency(number);
        case _constants_region__WEBPACK_IMPORTED_MODULE_0__/* .REGION_OPTION.ID */ .Em.ID:
            return numberToIdCurrency(number);
        default:
            return number.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            });
    }
};
var formatCurrencyLabelInArray = function(items) {
    return items === null || items === void 0 ? void 0 : items.map(function(item) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
            label: numberToCurrency(parseInt(item.value, 10))
        });
    });
};
// export const roundDownToDecimalPlaces = (number, decimalPlaces = 2) => {
//   const factor = Math.pow(10, decimalPlaces);
//   return Math.floor(number * factor) / factor;
// };
var formatCurrencyDecimal = function(number) {
    return parseFloat(number);
};


/***/ }),

/***/ 63197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ checkUnknownError; }
/* harmony export */ });
/* harmony import */ var src_constants_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74092);
/* eslint-disable import/prefer-default-export */ 
/**
 * check is unknown error.
 * @param error error object any type.
 * @returns true if error is unknown error and false when it's known error.
 */ var checkUnknownError = function(error) {
    return (error === null || error === void 0 ? void 0 : error.code) === src_constants_error__WEBPACK_IMPORTED_MODULE_0__/* .ERROR_CODE.TECHNICAL_ERROR */ .B.TECHNICAL_ERROR || !(error === null || error === void 0 ? void 0 : error.code) || typeof error.code !== "string" || !Object.keys(src_constants_error__WEBPACK_IMPORTED_MODULE_0__/* .BUSINESS_ERROR_CODE */ .b).find(function(errorKey) {
        return src_constants_error__WEBPACK_IMPORTED_MODULE_0__/* .BUSINESS_ERROR_CODE */ .b[errorKey] === error.code;
    }) && !((error === null || error === void 0 ? void 0 : error.code) === src_constants_error__WEBPACK_IMPORTED_MODULE_0__/* .ERROR_CODE.AUTHENTICATION_ERROR */ .B.AUTHENTICATION_ERROR);
};


/***/ }),

/***/ 65934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lt": function() { return /* binding */ filterParams; },
/* harmony export */   "YN": function() { return /* binding */ genPlanDirectLinkShareUrl; },
/* harmony export */   "j4": function() { return /* binding */ formatPathByLogicalGroupChannel; }
/* harmony export */ });
/* unused harmony export getUrlWithQuery */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var src_constants_params__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62090);
/* harmony import */ var src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85760);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable import/prefer-default-export */ 






var filterParams = function(params) {
    var includeList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_constants_params__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_PARAMS */ .g_;
    return Object.keys(params || {}).filter(function(key) {
        return includeList.includes(key);
    }).reduce(function(obj, key) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, obj), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, key, params[key]));
    }, {});
};
// we don't need /${channelPath} in retail
var formatPathByLogicalGroupChannel = function(path) {
    var logicalGroupChannel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_5__/* .LOGICAL_GROUP_CHANNEL_CODE */ .V;
    return logicalGroupChannel !== src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_5__/* .RETAIL_LOGICAL_GROUP_CHANNEL_CODE */ .b ? path : path.replace(/^\/?[^/]+/, "") || "/";
};
var genPlanDirectLinkShareUrl = function(param, lang) {
    var channelPath = param.channelPath, categoryCode = param.categoryCode, planCode = param.planCode, originUrl = param.originUrl, sRefCode = param.sRefCode;
    var utmQueryString = "".concat(src_constants_params__WEBPACK_IMPORTED_MODULE_1__/* .UTM_PARAMS.UTM_SOURCE */ .Yz.UTM_SOURCE, "=sharebutton&").concat(src_constants_params__WEBPACK_IMPORTED_MODULE_1__/* .UTM_PARAMS.UTM_MEDIUM */ .Yz.UTM_MEDIUM, "=healthplanpage&").concat(src_constants_params__WEBPACK_IMPORTED_MODULE_1__/* .UTM_PARAMS.UTM_CAMPAIGN */ .Yz.UTM_CAMPAIGN, "=").concat(planCode);
    var sRefCodeQueryString = sRefCode ? "&sRefCode=".concat(sRefCode) : "";
    var planDirectLinkPath = formatPathByLogicalGroupChannel("/".concat(channelPath, "/content-direct/").concat(categoryCode, "/plan/").concat(planCode, "?").concat(utmQueryString).concat(sRefCodeQueryString));
    var planDirectLinkUrl = "".concat(originUrl, "/").concat(lang).concat(planDirectLinkPath);
    return planDirectLinkUrl;
};
// only support simple flat query object
var getUrlWithQuery = function(path, query) {
    return "".concat(path).concat(isEmpty(query) ? "" : "?".concat(Object.entries(query).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], val = _param[1];
        return "".concat(key, "=").concat(val);
    }).join("&")));
};


/***/ })

}]);